import { Injectable } from "@angular/core";
import { HorizontalListData, HorizontalListFactory } from "common";
import { SalesforceUrlPipe } from "../../../../../shared/pipes/salesforce-url.pipe";
import { OfferDetailsData } from "./models/offer-details-data.model";

@Injectable()
export class OfferDetailsAdapter {
  constructor(
    private readonly salesforceUrlPipe: SalesforceUrlPipe,
  ) { }

  adaptProductListData = (data: OfferDetailsData): HorizontalListData[] => {
    return [
      HorizontalListFactory.createKeyValueRouterLinkItem({
        title: 'Offer bundle name',
        displayedValue: data?.offerBundle?.name,
        routerLink: data?.offerBundle?.id ? `/application/${data?.application?.id}/offer-bundle/${data.offerBundle?.id}` : undefined,
        isValueHidden: !data?.offerBundle?.name
      }),
      HorizontalListFactory.createKeyValueExternalLinkItem({
        title: 'Salesforce offer bundle ID',
        displayedValue: data?.offerBundle?.uniqueId,
        externalLink: this.salesforceUrlPipe.transform(data?.offerBundle?.uniqueId),
        isValueHidden: !data?.offerBundle?.uniqueId
      }),
      HorizontalListFactory.createKeyValueRouterLinkItem({
        title: 'Renewal for loan',
        displayedValue: data?.application?.renewalForLoanNumber,
        routerLink: data?.application?.renewalForLoanId ? `/account/${data?.application?.renewalForLoanId}/profile` : undefined,
        isValueHidden: !data.application?.renewalForLoanNumber || !data.application?.renewalForLoanId
      }),
    ]
  }
}